import Vue from 'vue';
import App from './App.vue';
import VueMeta from 'vue-meta';
import router from './router';
import VueResource from 'vue-resource';
import './registerServiceWorker';


Vue.config.productionTip = false;

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faTrafficLight, faClinicMedical, faShieldAlt, faExclamationTriangle, faUserShield, faAmbulance, faEnvelope, faUsers }  from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp }  from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faTrafficLight,faClinicMedical, faShieldAlt, faWhatsapp, faExclamationTriangle,faUserShield,faAmbulance, faEnvelope, faUsers)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueResource);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

new Vue({
  router,
  created() {
    Vue.http.options.root = process.env.VUE_APP_API_URL;
  },
  render: h => h(App)
}).$mount('#app');
